import { report } from './index';
export function buryingPoint (title, axios) {
	let itemid = ''
	if (['抽奖', '活跃抽奖', '登录抽奖', '每日抽奖', '不删档抽奖', '不删档活跃抽奖', '不删档登录抽奖',
		'不删档每日抽奖'].indexOf(title) >= 0) {
		itemid = '12012'
	} else if (['分享活动', '分享好友', '转发', '转发分享', '转发好友'].indexOf(title) >= 0) {
		itemid = '12013'
	} else if (['领取抽奖资格', '领取新手礼获得抽奖资格', '领取等级礼获得抽奖资格', '领取注册礼获得抽奖资格',
		'领取战力礼获得抽奖资格', '领取预约礼获得抽奖资格', '预约获得抽奖资格',
		'领取充值礼获得抽奖资格'].indexOf(title) >= 0) {
		itemid = '12014'
	}
	report(itemid)
}



// WEBPACK FOOTER //
// ./src/components/actModules/h5/templates/buryingPoint/luckDraw.js